module.exports = __webpack_public_path__ + "static/media/S (107).6f1f4253.jpg";